// Provide services for Cms Featured Seller
const CmsHomepageSectionService = {

  /**
   * Format JSON object to FormData
   *
   * @param {object} obj - JSON object
   * @param {FormData} form - Form data
   * @param {string} namespace - Form data namespace
   * @param {boolean} isArray - To know if the child is an array object
   */
  toFormData: (obj, form, namespace, isArray = false) => {
    let fd = form || new FormData()
    let formKey

    for (let property in obj) {
      if (namespace) {
        if (isArray) {
          formKey = namespace + '[]'
        } else {
          formKey = namespace + '[' + property + ']'
        }
      } else {
        formKey = property
      }
      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString())
      }
      else if (obj[property] instanceof Array) {
        CmsHomepageSectionService.toFormData(obj[property], fd, formKey, true)
      }
      else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
        CmsHomepageSectionService.toFormData(obj[property], fd, formKey)
      } else { // if it's a string or a File object
        fd.append(formKey, obj[property])
      }
    }

    return fd
  },
  /**
   * Build payload for single Image payload
   *
   * @param {object} image - image object
   */
  prepImage: (image) => {
    let imagePayload = ''

    // add image to imagePayload if image uploaded
    if (image.size !== 0){
      imagePayload = image
    }

    return imagePayload
  },
  /**
   * Build payload for texts payload that can be null value
   *
   * @param {text} string - text value of payload that can be null value
   */
  prepText: (text) => {
    let textPayload = ''

    if (text !== null){
      textPayload = text
    }

    return textPayload
  }

}

export default CmsHomepageSectionService
